var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoeditor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 8V16H5V8H15ZM17 10.5V7C17 6.73478 16.8946 6.48043 16.7071 6.29289C16.5196 6.10536 16.2652 6 16 6H4C3.73478 6 3.48043 6.10536 3.29289 6.29289C3.10536 6.48043 3 6.73478 3 7V17C3 17.2652 3.10536 17.5196 3.29289 17.7071C3.48043 17.8946 3.73478 18 4 18H16C16.2652 18 16.5196 17.8946 16.7071 17.7071C16.8946 17.5196 17 17.2652 17 17V13.5L19.29 15.79C19.4299 15.931 19.6086 16.0272 19.8033 16.0663C19.9981 16.1054 20.2 16.0855 20.3835 16.0094C20.5669 15.9332 20.7235 15.8041 20.8333 15.6386C20.9431 15.4731 21.0012 15.2786 21 15.08V8.91C21.0012 8.71138 20.9431 8.51691 20.8333 8.35139C20.7235 8.18587 20.5669 8.0568 20.3835 7.98063C20.2 7.90446 19.9981 7.88465 19.8033 7.92372C19.6086 7.96279 19.4299 8.05897 19.29 8.2L17 10.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoeditor);
export default __webpack_public_path__ + "static/media/videoeditor.72a1fc27faa1560cbde3c4325dc73287.svg";
export { ForwardRef as ReactComponent };